module.exports = __webpack_public_path__ + "img/borrar.f8a3af20.png";